import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../services/api.service';

const DEFAULT_FILE_NAME = 'Fleet-Modele-import-tournees.xlsx';

/**
 * Télécharge le modèle de l'import de tournées au format standard
 * (GET /tours/upload/template, OTHERS.UPLOAD.STANDARD_TEMPLATE). Il est généré
 * par l'API depuis la déclaration de colonnes qui sert aussi à relire le
 * fichier déposé.
 *
 * @returns {object} - { isDownloading, downloadTemplate }
 */
export default function useDownloadUploadTemplate() {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadTemplate = useCallback(async () => {
    setIsDownloading(true);
    try {
      const response = await fleetApi.get('/tours/upload/template', {
        responseType: 'blob',
      });

      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.download =
        response.headers?.['content-disposition']?.match(
          /filename="?([^"]+)"?/
        )?.[1] || DEFAULT_FILE_NAME;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Le modèle n'a pas pu être téléchargé.");
    } finally {
      setIsDownloading(false);
    }
  }, []);

  return { isDownloading, downloadTemplate };
}
